import { render, staticRenderFns } from "./CrmRelativeCell.vue?vue&type=template&id=55f28c6e&scoped=true&"
import script from "./CrmRelativeCell.vue?vue&type=script&lang=js&"
export * from "./CrmRelativeCell.vue?vue&type=script&lang=js&"
import style0 from "./CrmRelativeCell.vue?vue&type=style&index=0&id=55f28c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f28c6e",
  null
  
)

component.options.__file = "CrmRelativeCell.vue"
export default component.exports